import React, { useMemo } from "react";

import { CoverDataItem, DamageClassItem, NewAnomalyItem } from "../../../../utils/models";
import { getIsAnomalyType, getIsAnomalyWithCMD } from "../../../../utils/utilities";
import { AnomalyItemWithPDO } from "../../../forms/custom-fvi/anomalyWithPDO";

import AnomalyTypes from "../../custom-visual-inspection/piping-anomalies/anomaly-types";
import AnomalyItemWithCMD from "../../../forms/custom-fvi/anomalyItemWithCMD";
import AnomalyItemType from "../../../forms/custom-fvi/anomalyItemType";
import NewPipingAnomalyItems from "../../custom-visual-inspection/piping-anomalies/new-piping-anomalies";
import PDOPipingAnomalyItems from "../../custom-visual-inspection/piping-anomalies/pdo-piping-anomalies";
import UTMAnomalies from "../../custom-visual-inspection/piping-anomalies/utm-anomalies";

import useProjectDetails from "../../../../hooks/useProjectDetails";

interface Props {
    locationOptions: CoverDataItem[];
    damageClasses: DamageClassItem[];
    nextAnomalyID: number;
    isPDOFormat: boolean;
    isNewFormat: boolean;
    items: NewAnomalyItem[];
    onDataChange: (items: NewAnomalyItem[]) => void;
}

const CustomAnomalyItems: React.FC<Props> = ({ damageClasses, isNewFormat, isPDOFormat, items, locationOptions, nextAnomalyID, onDataChange }) => {
    const { projectDetails } = useProjectDetails();

    const isAnomalyWithCMD = useMemo(() => {
        return projectDetails && getIsAnomalyWithCMD(projectDetails);
    }, [projectDetails]);

    const isAnomalyTpe = useMemo(() => {
        return projectDetails && getIsAnomalyType(projectDetails);
    }, [projectDetails]);

    if (isPDOFormat) {
        return (
            <PDOPipingAnomalyItems
                nextAnomalyID={nextAnomalyID}
                damageClasses={damageClasses}
                anomalyItems={items as AnomalyItemWithPDO[]}
                onDataChange={(items) => onDataChange(items)}
            />
        );
    }

    console.log('using 1');

    if (isAnomalyWithCMD) {
        return (
            <AnomalyTypes
                FormComponent={AnomalyItemWithCMD}
                locationOptions={locationOptions}
                nextAnomalyID={nextAnomalyID}
                anomalyItems={items}
                onDataChange={(items) => onDataChange(items)}
            />
        );
    }

    console.log('using 2');

    if (isAnomalyTpe) {
        console.log('using 2 step');
        console.log(locationOptions);
        return (
            <AnomalyTypes
                FormComponent={AnomalyItemType}
                locationOptions={locationOptions}
                nextAnomalyID={nextAnomalyID}
                anomalyItems={items}
                onDataChange={(items) => onDataChange(items)}
            />
        )
    }

    console.log('using 3');

    if (isNewFormat) {
        return (
            <UTMAnomalies
                locationOptions={locationOptions}
                nextAnomalyID={nextAnomalyID}
                damageClasses={damageClasses}
                anomalyItems={items}
                onDataChange={(items) => onDataChange(items)}
            />
        )
    }

    console.log('using 4');
    
    return ( 
        <NewPipingAnomalyItems
            nextAnomalyID={nextAnomalyID}
            damageClasses={damageClasses}
            anomalyItems={items}
            onDataChange={(items) => onDataChange(items)}
        />
    );
};
 
export default CustomAnomalyItems;